<template>

	<div class="topbars">
		<div class="w1510" :class="locale">
			<a class="logo" :href="path+'/'"><img :src="require('../assets/img/'+$t('tpdz')+'logo.png')"></a>
			
			<div class="topbar">
				<ul>
					<li :class="{'activeMenu':activeMenu1}">
						<a @click="menuChange(1)" :href="path+'/about'">{{ $t('gyKoreSemi') }}</a>
						<dl>
							<dd>
								<a :href="path+'/about'">{{$t('gsjj')}}</a>
							</dd>
							<dd>
								<a :href="path+'/gszl'">{{$t('gszl')}}</a>
							</dd>
							<!-- <dd>
								<a :href="path+'/news'">{{$t('xwzx')}}</a>
							</dd> -->
							
							<!-- <dd>
								<a href="/llwm">联络我们</a>
							</dd>
							<dd>
								<a href="/flsm">法律声明</a>
							</dd>
							<dd>
								<a href="/ysqzc">隐私权政策</a>
							</dd> -->
						</dl>
					</li>
					<!-- <li v-bind:class="{'activeMenu':activeMenu2}">
						<a @click="menuChange(2)" :href="path+'/yfjh'">{{$t('xjjs')}}</a>
						<dl>
							<dd>
								<a :href="path+'/yfjh'">{{$t('yfjh')}}</a>
							</dd>
							<dd>
								<a :href="path+'/Co-Package'">Co-Package Optics</a>
							</dd>
							<dd>
								<a :href="path+'/FOStrip'">FOStrip®</a>
							</dd>
							<dd>
								<a :href="path+'/Hyper'">Hyper 2D®</a>
							</dd>
							<dd>
								<a :href="path+'/FOAIP'">FOAiP</a>
							</dd>
							
						</dl>
					</li> -->
					<li v-bind:class="{'activeMenu':activeMenu3}">
						<a @click="menuChange(3)" :href="path+'/jyjfz'">{{$t('fwnr')}}</a>
						<dl>
							<dd>
								<a :href="path+'/jyjfz'">{{$t('jyjfz')}}</a>
							</dd>
							<dd>
								<a :href="path+'/csfw'">{{$t('csfw')}}</a>
							</dd>
							<dd>
								<a :href="path+'/dps'">{{$t('dps')}}</a>
							</dd>
							<dd>
								<a :href="path+'/turnkey'">Turnkey Service</a>
							</dd>
							
						</dl>
					</li>
					<li v-bind:class="{'activeMenu':activeMenu4}">
						<a @click="menuChange(4)" :href="path+'/yjysm'">{{$t('qyzr')}}</a>
						<dl>
							<dd>
								<a :href="path+'/yjysm'">{{$t('yjysm')}}</a>
							</dd>
							<dd>
								<a :href="path+'/qyjyln'">{{$t('qyjyln')}}</a>
							</dd>
							<dd>
								<a :href="path+'/pgzc'">{{$t('pgzc')}}</a>
							</dd>
						</dl>
					</li>
					<li v-bind:class="{'activeMenu':activeMenu5}">
						<a @click="menuChange(5)" :href="path+'/llwm'">{{$t('llwm')}}</a>
						<!--<dl>
							<dd>
								<a :href="path+'/jrwm'">{{$t('rczp')}}</a>
							</dd>
						</dl>-->
					</li>
					<li>
						<a href="javascript:void(0)">{{locale}}<i class="iconfont">&#xe607;</i></a>
						<dl class="yy">
							<dd>
								<a @click="changeLocale('chj')" href="javascript:void(0)">{{ $t('jiant') }}</a>
							</dd>
							<dd>
								<a @click="changeLocale('chf')" href="javascript:void(0)">{{ $t('fant') }}</a>
							</dd>
							<dd>
								<a @click="changeLocale('en')" href="javascript:void(0)">{{ $t('english') }}</a>
							</dd>
						</dl>
					</li>
				</ul>
			</div>
			<div class="sjys">
				<i @click='zl=!zl' v-if="!zl" class="iconfont lb">&#xe61e;</i>
				<i @click='zl=!zl' v-else class="iconfont">&#xe634;</i>
				<div class="subnav" v-if="zl">
					<ul>
						<li>
							<a @click.stop='zl1=!zl1;zl5=false;zl2=false;zl3=false;zl4=false;' >{{$t('gsjj')}}</a>
							<dl v-if="zl1">
								<dd>
									<a :href="path+'/about'">{{$t('gsjj')}}</a>
								</dd>
								<dd>
									<a :href="path+'/gszl'">{{$t('gszl')}}</a>
								</dd>
								<!-- <dd>
									<a :href="path+'/news'">{{$t('xwzx')}}</a>
								</dd> -->
							</dl>
						</li>
						<!-- <li>
							<a @click.stop='zl2=!zl2;zl1=false;zl5=false;zl3=false;zl4=false;'>{{$t('xjjs')}}</a>
							<dl v-if="zl2">
								<dd>
									<a :href="path+'/yfjh'">{{$t('yfjh')}}</a>
								</dd>
								<dd>
									<a :href="path+'/Co-Package'">Co-Package Optics</a>
								</dd>
								<dd>
									<a :href="path+'/FOStrip'">FOStrip®</a>
								</dd>
								<dd>
									<a :href="path+'/Hyper'">Hyper 2D®</a>
								</dd>
								<dd>
									<a :href="path+'/FOAIP'">FOAiP</a>
								</dd>
								
							</dl>
						</li> -->
						<li>
							<a @click.stop='zl3=!zl3;zl1=false;zl2=false;zl5=false;zl4=false;'>{{$t('fwnr')}}</a>
							<dl v-if="zl3">
								<dd>
									<a :href="path+'/jyjfz'">{{$t('jyjfz')}}</a>
								</dd>
								<dd>
									<a :href="path+'/csfw'">{{$t('csfw')}}</a>
								</dd>
								<dd>
									<a :href="path+'/dps'">{{$t('dps')}}</a>
								</dd>
								<dd>
									<a :href="path+'/turnkey'">Turnkey Service</a>
								</dd>
								
							</dl>
						</li>
						<li>
							<a  @click.stop='zl4=!zl4;zl1=false;zl2=false;zl3=false;zl5=false;'>{{$t('qyzr')}}</a>
							<dl v-if="zl4">
								<dd>
									<a :href="path+'/yjysm'">{{$t('yjysm')}}</a>
								</dd>
								<dd>
									<a :href="path+'/qyjyln'">{{$t('qyjyln')}}</a>
								</dd>
								<dd>
									<a :href="path+'/pgzc'">{{$t('pgzc')}}</a>
								</dd>
							</dl>
						</li>
						<li>
							<a  @click.stop='zl5=!zl5;zl1=false;zl2=false;zl3=false;zl4=false;'>{{$t('jrwm')}}</a>
							<dl v-if="zl5">
								<dd>
									<a :href="path+'/jrwm'">{{$t('rczp')}}</a>
								</dd>
							</dl>
						</li>
						<li>
							<!-- <a href="">CN<i class="iconfont">&#xe607;</i></a> -->
							<a @click.stop='zl6=!zl6;' href="javascript:void(0)">{{locale}}<i class="iconfont">&#xe607;</i></a>
							<dl class="yy" v-if="zl6">
								<dd>
									<a @click="changeLocale('chj');zl=!zl" href="javascript:void(0)">{{ $t('jiant') }}</a>
								</dd>
								<dd>
									<a @click="changeLocale('chf');zl=!zl" href="javascript:void(0)">{{ $t('fant') }}</a>
								</dd>
								<dd>
									<a @click="changeLocale('en');zl=!zl" href="javascript:void(0)">{{ $t('english') }}</a>
								</dd>
							</dl>
						</li>
					</ul>
				</div>
				<!-- <i class="iconfont">&#xe634;</i> -->
			</div>
		</div>
		<div :class="locale"><router-view></router-view></div>
		<div class="bottom" :class="locale">
			<div class="w1340">
				<div class="le">
					<a :href="path+'/flsm'">{{ $t('flsm') }}</a>
					<a :href="path+'/jrwm'">{{ $t('rczp') }}</a>
					<a href="javascript:void(0)">{{ $t('csrk') }}</a>
					<!-- <a target="_blank" href="http://oa.koresemi.com/UOF">{{ $t('ygrk') }}</a> -->
					<div>
						<!-- <a href="/"><img src="../assets/img/twitter.png" alt=""></a> -->
						<a class="codes" href="javascript:void(0)">
							<img src="../assets/img/we-chat.png" alt="">
							<img class="code" src="../assets/img/code2.png" >
						</a>
						<!-- <a href="/"><img src="../assets/img/in.png" alt=""></a> -->
						<a href="https://www.linkedin.com/company/kore-semiconductor"><img src="../assets/img/linkedin.png" alt=""></a>
					</div>
				</div>
				<div class="ri">
					<ul>
						<li>
							<div class="t">
								{{ $t('gywm') }}
							</div>
							<a :href="path+'/about'">{{ $t('gsjj') }}</a>
							<a :href="path+'/gszl'">{{ $t('gszl') }}</a>
							<!-- <a :href="path+'/news'">{{ $t('xwzx') }}</a> -->
						</li>
						<!-- <li>
							<div class="t">
								{{ $t('xjjs') }}
							</div>
							<a :href="path+'/yfjh'">{{ $t('yfjh') }}</a>
							<a :href="path+'/Co-Package'">Co-Package Optics</a>
							<a :href="path+'/FOStrip'">FOStrip®</a>
							<a :href="path+'/Hyper'">Hyper 2D®</a>
							<a :href="path+'/FOAIP'">FOAiP</a>
						</li> -->
						<li>
							<div class="t">
								{{ $t('fwnr') }}
							</div>
							<a :href="path+'/jyjfz'">{{ $t('jyjfz') }}</a>
							<a :href="path+'/csfw'">{{ $t('csfw') }}</a>
							<a :href="path+'/dps'">{{$t('dps')}}</a>
							<a :href="path+'/turnkey'">Turnkey Service</a>
						</li>
						<li>
							<div class="t">
								{{ $t('qyzr') }}
							</div>
							<a :href="path+'/yjysm'">{{ $t('yjysm') }}</a>
							<a :href="path+'/qyjyln'">{{ $t('qyjyln') }}</a>
							<a :href="path+'/pgzc'">{{ $t('pgzc') }}</a>
						</li>
						<li>
							<div class="t">
								<a :href="path+'/llwm'" style="font-size: 18px;padding: 0 0 12px;">{{ $t('llwm') }}</a>
							</div>
							<!--<a :href="path+'/jrwm'">{{ $t('rczp') }}</a>-->
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="footer" :class="locale">
			<div class="w1340">
				<img src="../assets/img/foxconn_img.png" alt="">copyright@2020 Kore Semiconductor Co., Ltd. <a target="_blank" style="color:#73859d;" href="https://beian.miit.gov.cn/#/Integrated/index"><img class="gabz" src="../assets/img/gabz.png" />鲁公网安备 37021002000983号</a>
				中华人民共和国信息产业部备案管理系统查询网址 <a target="_blank" style="color:#73859d;" href="https://beian.miit.gov.cn">beian.miit.gov.cn</a>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				zl:false,
				zl1:false,
				zl2:false,
				zl3:false,
				zl4:false,
				zl5:false,
				zl6:false,
				locale:'简体',
				activeMenu1:false,
				activeMenu2:false,
				activeMenu3:false,
				activeMenu4:false,
				activeMenu5:false,
				path:null,
			}
		},
		created() {
			this.path = process.env.VUE_APP_CONTEXT_RESOURCE;
			// console.log("this.path:"+this.path);
			if(this.path==""){
				this.path = "http://www.koresemi.com";
			}//console.log("this.path2:"+this.path);

			let url = window.location.href;
			
			if(url.indexOf("about")>-1||url.indexOf("gszl")>-1||url.indexOf("news")>-1){
				this.activeMenu1 = true;
			}else if(url.indexOf("/yfjh")>-1||url.indexOf("/Co-Package")>-1||url.indexOf("/FOStrip")>-1||url.indexOf("/Hyper")>-1||url.indexOf("/FOAIP")>-1){
				this.activeMenu2 = true;
			}else if(url.indexOf("/jyjfz")>-1||url.indexOf("/csfw")>-1||url.indexOf("/dps")>-1||url.indexOf("/turnkey")>-1){
				this.activeMenu3 = true;
			}else if(url.indexOf("/yjysm")>-1||url.indexOf("/qyjyln")>-1||url.indexOf("/pgzc")>-1){
				this.activeMenu4 = true;
			}else if(url.indexOf("/jrwm")>-1){
				this.activeMenu5 = true;
			}else{
				this.activeMenu1 = true;
			}

			let that=this
			if(!localStorage.getItem('lan')){
				that.$i18n.locale ='chj'
			}else{
				that.$i18n.locale = localStorage.getItem('lan')
			}
			
			if(localStorage.getItem('lan')=='en'){
				that.locale = 'English'
			}
			if(localStorage.getItem('lan')=='chj'){
				that.locale = '简'
			}
			if(localStorage.getItem('lan')=='chf'){
				that.locale = '繁'
			}
			// this.locale = localStorage.getItem('lan')

			
		},
		methods:{
			changeLocale(e) {
			  let locale = this.$i18n.locale,that=this
			   this.$i18n.locale = e
			   localStorage.setItem('lan',e)
			   if(e=='en'){
			   	that.locale = 'English'
			   }
			   if(e=='chj'){
			   	that.locale = '简'
			   }
			   if(e=='chf'){
			   	that.locale = '繁'
			   }
			}
		}
	}
</script>

<style>
</style>
